export const NATION_CODE_OPTIONS = [
  'TWN',
  // 'AFR',
  // 'CAA',
  // 'CHN',
  // 'EAA',
  // 'EUR',
  // 'JPN',
  // 'KOR',
  // 'NAA',
  // 'NMA',
  // 'OCE',
  // 'SAA',
  // 'SEMA',
  // 'SMA',
  // 'USA',
  // 'WAA',
];

export const TW_COUNTY_OPTIONS = [
  '台北市',
  '新北市',
  '桃園市',
  '高雄市',
  '新竹市',
  '新竹縣',
  '台中市',
  '台東縣',
  '台南市',
  '基隆市',
  '宜蘭縣',
  '花蓮縣',
  '金門縣',
  '南投縣',
  '屏東縣市',
  '苗栗縣',
  '連江縣',
  '雲林縣',
  '嘉義市',
  '嘉義縣',
  '彰化縣',
  '澎湖縣',
];
